/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_Annotated_PdfInputs */

const en_open_annotated_pdf = /** @type {(inputs: Open_Annotated_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open annotated PDF`)
};

const de_open_annotated_pdf = /** @type {(inputs: Open_Annotated_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annotiertes PDF öffnen`)
};

/**
* | output |
* | --- |
* | "Open annotated PDF" |
*
* @param {Open_Annotated_PdfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const open_annotated_pdf = /** @type {((inputs?: Open_Annotated_PdfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_Annotated_PdfInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_open_annotated_pdf(inputs)
	return en_open_annotated_pdf(inputs)
});